module.exports = __webpack_public_path__ + "img/page_recargate_slider_01.3c911587.png";